import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createAtmServiceProvider = ( {data} : {data: IPostNewAtmServiceProvider | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/AtmServiceProviders/InsertAtmServiceProvider`, data);
};

type QueryFnType = typeof createAtmServiceProvider;

type UseCreateAtmServiceProviderOptions = {
  data: IPostNewAtmServiceProvider | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateAtmServiceProvider = ({ config }: UseCreateAtmServiceProviderOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του ATM Service Provider.`, 500);
            console.error('Couldnt create new atm service provider', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllAtmServiceProviders"])
            addNotification("Δημιουργήθηκε Νέο ATM Service Provider.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createAtmServiceProvider,
    })
}